import { render, staticRenderFns } from "./tiscButton.vue?vue&type=template&id=484199b8&scoped=true&"
import script from "./tiscButton.vue?vue&type=script&lang=js&"
export * from "./tiscButton.vue?vue&type=script&lang=js&"
import style0 from "./tiscButton.vue?vue&type=style&index=0&id=484199b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484199b8",
  null
  
)

export default component.exports